module.exports = __webpack_public_path__ + "img/sad.48c93baa.svg";